<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<app-view-common-disparity :value="item.rating.rating" :average="item.game.rating_avg" v-if="isUser" class="disparity" />
	<app-view-common-disparity :value="item.group.rating_avg" :average="item.game.rating_avg" v-if="!isUser" class="disparity" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted']

}

</script>

<style scoped>

.disparity {
    font-size: 18px;
}

</style>